<template>

    <div class="container-2">

      <div class="container-2-left">
        <div id="slider">
          <figure>
            <img src="../assets/FriedRiceVeggie.png">
            <img src="../assets/Jjampong.png">
            <img src="../assets/DumplingDeepFried.png"> 
            <img src="../assets/Ramen.png">   
            <img src="../assets/FriedRiceVeggie.png">
          </figure>
        </div>

      </div>

      <div class="container-2-right">

        <div>
          <router-link to="/Combo"> 
            <button class="text-combo">Combo</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Noodle"> 
            <button class="text-noodle">Noodle</button>
          </router-link>
        </div>

        <div>
          <router-link to="/Dumpling"> 
            <button class="text-dumpling">Dumpling</button>
          </router-link>
        </div>

        <div>
          <router-link to="/FriedRice"> 
            <button class="text-fried-rice">Fried Rice</button>
          </router-link>
        </div>

      </div>

    </div>


  <router-view/>


</template>

<script>

  export default {
    name: 'HomeBody2'
  }

</script>


  
<style scoped>

/* for bigger screen */
@media (min-width:700px) {

/* 2nd Container */
.container-2 {
    display: grid;
    grid-template-columns: 1fr 2fr;
    background-color: rgb(238, 238, 238);
    height: 25vw;
    margin-top: 0.5rem;
}


.container-2-left {
    place-items: center;    
    width: 78%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */

 }


  .text-combo {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 6vw;
    margin-left: -35vw;
  }

  .text-noodle {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: -10vw;
  }


  .text-dumpling {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

  .text-fried-rice {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1vw;
    margin-top: 2vw;
    margin-left: 35vw;
  }

}


/* for Phone */
@media (max-width:700px) {
  
/* 2nd Container */
.container-2 {
    display: grid;
    grid-template-columns: 1fr 2fr;
    background-color: rgb(238, 238, 238);
    height: 25vw;
    margin-top: 0.5rem;
}

.container-2-left {
    place-items: center;    
    width: 80%;
    height: 25vw;
    margin: auto;
  }

  #slider {
    overflow: hidden;
  }

  #slider figure {
    position: relative;
    width: 500%;
    height: 100%;
    margin: 0;
    left: 0;
    object-fit: cover;
    animation: 30s slider infinite; 
  } 

  #slider figure img {
    float: left;
    width: 20%;  /* 100 / 5 including last image (dup of image1) */ 
    transform: translate3d(0, 0, 0); /* prevents potential flickering on some browsers */
    backface-visibility: hidden;
  }


@keyframes slider {

    /* Calculation: Each image is displayed for 5s (static) and move in 1s (transition)
       Total steps are 7 (including the duplicate), but we have 6 transitions
       Each image's stop point percentage is (index * 6s / 30s * 100%)
       Move point is (index * 6s - 1s / 30s * 100%)
    */

    /* image 1: End hold at 5s */
    0% {transform: translateX(0);}
    16.67% {transform: translateX(0);} /* 5s/30s*100, stay at 0% */
    20% {transform: translateX(-20%);} /* 6s/30s*100, move to image 2 */


    /* Image 2: End hold at 11s, move to image 3 at 12s */
    36.67% {transform: translateX(-20%);} /* 11s/30s*100 */
    40% {transform: translateX(-40%);} /* 12s/30s*100 */


    /* Image 3: End hold at 17s, move to image 4 at 18s */
    56.67% {transform: translateX(-40%);} /* 17s/30s*100 */
    60% {transform: translateX(-60%);} /* 18s/30s*100 */

    /* Image 4: End hold at 23s, move to image 5 at 24s */
    76.67% {transform: translateX(-60%);} /* 23s/30s*100 */
    80% {transform: translateX(-80%);} /* 24s/30s*100 */  

    /* Image 5 (duplicate of Image 1): End hold at 29s, Infinite reset at 30s */
    96.67% {transform: translateX(-80%);} /* 29s/30s*100 */   

    100% {transform: translateX(-80%);}  /* 30s/30s*100 */

 }


  .text-combo {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 6vw;
    margin-left: -35vw;
  }

  .text-noodle {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: -10vw;
  }

  .text-dumpling {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 10vw;
  }

  .text-fried-rice {
    cursor: pointer;
    border: none;
    outline: none;
    color: darkblue;
    font-style: optima;
    font-size: 1.05rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 2vw;
    margin-left: 35vw;
  }

}

</style>